document.addEventListener('DOMContentLoaded', function() {
  // display hint or error message upon clicking .help-icon
  var elements = document.getElementsByClassName('help-icon');
  Array.from(elements).forEach(function(element) {
    element.addEventListener('click', function() {
      element.closest(".icon-parent").querySelector(".input-error").classList.toggle("d-inline");
    });
  });
  /*
  var dropdowns = document.getElementsByClassName('dropdown-input');
  Array.from(dropdowns).forEach(function(element) {
    element.addEventListener('click', function () {
      var dropdownContent = element.querySelector(".dropdown-content")
      dropdownContent.style.display = (dropdownContent.style.display === 'block') ? 'none' : 'block';
    });
  });
  */
});
